export default __webpack_public_path__ + "static/pc-hero-right-1562256ba884d8d4572330542ee16f68.svg";